export { Spoiler } from './spoiler';
export type { SpoilerProps, SpoilerStylesNames } from './spoiler';
